import { OctagonAlert } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const AlertOctagonIcon = createLucideIcon(OctagonAlert);
